module.exports = __webpack_public_path__ + "static/media/46.33a10eda.png";